import React, { useEffect, useState } from 'react'
import { Container } from 'react-bootstrap'
import { isPermissionExist, isPromoValidateButton, messageSuccessPayment, sortPortalPermissionByKey } from '../../utils/helper'
import QRCode from 'react-qr-code'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import { EMPTY_ARRAY, EMPTY_OBJECT } from '../../constants/globalConstants'
import { getConfigDetails } from '../../services/config'

function QRCodeComp(props) {
    const {paymentData, isMessage, isLicensePlate, screen, payResponse, partnerDetails} = props
    const [paymentResponse, setPaymentResponse] = useState(EMPTY_OBJECT)
    const [extendResponse, setExtendResponse] = useState(EMPTY_OBJECT)
    const getAccessPermissionData = sortPortalPermissionByKey(partnerDetails, 'Restricted Permissions')
    useEffect(() => {
        const paymentResponse = JSON.parse(localStorage.getItem('paymentRecipt'))
        const extendResponse = JSON.parse(localStorage.getItem('ExtendData'))

        setExtendResponse(extendResponse)
        setPaymentResponse(paymentResponse)
        // console.log(paymentData, paymentResponse, 'paymentData')

    }, [EMPTY_ARRAY])
    
    
    return (
        <Container>
            {screen == 'extend' ? <div className='mt-4 align-items-center text-center mb-3'>
                <QRCode 
                    value={(extendResponse?.reservation && extendResponse?.reservation?.ticketech_code) ? extendResponse?.reservation?.ticketech_code : isPromoValidateButton(paymentData, ['2', '3']) ? `${window?.location?.toString()?.includes('rev-pass') ? getConfigDetails()?.revpartnerUrl : getConfigDetails()?.partnerUrl}/admin/tickets?ticket_number=${paymentData?.ticket_number}` : paymentData?.ticket_number} 
                    size="80" 
                />
                <p className='mt-3 text-primary fw-semibold mb-0 pb-0'>{`Ticket ID - ${paymentData?.ticket_number}`}</p>
                {(isLicensePlate && paymentData?.license_plate) && <p className={`${(paymentData?.permit_number || paymentData?.pass_number || paymentData?.booking_number || paymentData?.paid_remark) ? 'mb-0 ':''}mt-0 text-primary fw-semibold small`}>{`License Plate - ${paymentData?.license_plate}`}</p>}
                {paymentData?.permit_number ? <p className='mt-0 text-primary fw-semibold small'>{`Permit No - ${paymentData?.permit_number}`}</p> : paymentData?.pass_number ? <p className='mt-0 mb-0 p-0  text-primary fw-semibold small'>{`Pass ID - ${paymentData?.pass_number}`}</p> : paymentData?.booking_number ? <p className='mt-0 text-primary fw-semibold small'>{`Event ID - ${paymentData?.booking_number}`}</p> : ''}
                {(isPermissionExist(getAccessPermissionData, 'Display Pass Usages') && paymentData?.user_pass && paymentData?.user_pass?.total_days && paymentData?.user_pass?.pass_type != 3 ) ? <p className='mt-0 mb-0 p-0 text-primary fw-semibold small'>{`Total Usage - ${paymentData?.user_pass?.total_days}`}</p> : ''}
                {(isPermissionExist(getAccessPermissionData, 'Display Pass Usages') && paymentData?.user_pass && paymentData?.user_pass?.remaining_days && paymentData?.user_pass?.pass_type != 3 ) ? <p className='mt-0 mb-3 p-0 text-primary fw-semibold small'>{`Remaining Usage - ${paymentData?.user_pass?.remaining_days}`}</p> : ''}
                {isMessage && <small className='textColorText'>{messageSuccessPayment}</small>}
                {paymentData?.paid_remark && paymentData?.paid_remark != '' ? <p className='text-success fw-semibold mt-0 pt-0 small'>Validated</p> :  null}

            </div> : <div className='mt-4 row mb-3'>
                <div className='col-8 text-left'>
                    <p className='mt-3 text-primary fw-semibold mb-0 pb-0 small'>{`Ticket ID - ${paymentData?.ticket_number}`}</p>
                    {paymentData?.license_plate && <p className={`${(paymentData?.permit_number || paymentData?.pass_number || paymentData?.booking_number || paymentData?.paid_remark) ? 'mb-0 mb-1':''}mt-0 mb-1 text-primary fw-semibold small`}>{`License Plate - ${paymentData?.license_plate}`}</p>}
                     {(paymentData?.ticket_details?.is_fast_track_enabled=='1' || paymentData?.is_fast_track=='1') && paymentData?.fastTrackData &&  Object.keys(paymentData?.fastTrackData).length > 0 && <p className="mt-0 text-success fw-semibold small">Fast Track Enabled</p>}
                    {paymentData?.permit_number ? <p className='mt-0 text-primary fw-semibold small'>{`Permit No - ${paymentData?.permit_number}`}</p> : paymentData?.pass_number ? <p className='mt-0 mb-0 p-0  text-primary fw-semibold small'>{`Pass ID - ${paymentData?.pass_number}`}</p> : paymentData?.booking_number ? <p className='mt-0 text-primary fw-semibold small'>{`Event ID - ${paymentData?.booking_number}`}</p> : ''}
                    {(isPermissionExist(getAccessPermissionData, 'Display Pass Usages') && paymentData?.user_pass && paymentData?.user_pass?.total_days && paymentData?.user_pass?.pass_type != 3 ) ? <p className='mt-0 mb-0 p-0 text-primary fw-semibold small'>{`Total Usage - ${paymentData?.user_pass?.total_days}`}</p> : ''}
                    {(isPermissionExist(getAccessPermissionData, 'Display Pass Usages') && paymentData?.user_pass && paymentData?.user_pass?.remaining_days && paymentData?.user_pass?.pass_type != 3 ) ? <p className='mt-0 mb-3 p-0 text-primary fw-semibold small'>{`Remaining Usage - ${paymentData?.user_pass?.remaining_days}`}</p> : ''}
                    {paymentData?.paid_remark && paymentData?.paid_remark != '' ? <p className='text-success fw-semibold mt-0 pt-0 small'>Validated</p> :  null}
                    
                </div>
                <div className='col-4 text-end mb-3'>
                <QRCode 
                    value={(paymentResponse?.reservation && paymentResponse?.reservation?.ticketech_code) ? paymentResponse?.reservation?.ticketech_code : isPromoValidateButton(paymentData, ['2', '3']) ? `${window?.location?.toString()?.includes('rev-pass') ? getConfigDetails()?.revpartnerUrl : getConfigDetails()?.partnerUrl}/admin/tickets?ticket_number=${paymentData?.ticket_number}` : paymentData?.ticket_number} 
                    size="80" 
                />
                </div>
                {payResponse?.active_session_closed_msg ? <div className='col-12 mb-3'><p className='border rounded-3 p-2 text-center small m-0'><i className='fa fa-warning me-1 text-danger'></i>{payResponse?.active_session_closed_msg}<br />{messageSuccessPayment}</p></div> : 
                <small className='textColorText text-center'>{messageSuccessPayment}</small>}
                {paymentData?.paid_remark && paymentData?.paid_remark != '' ? 
                    <small className='text-success text-center mt-2'>
                        {paymentData?.paid_remark}
                    </small>
                :  null}
            </div>}
        </Container>
    )
}

QRCodeComp.propTypes = {
    dispatch: PropTypes.func,
    paymentData : PropTypes.object,
    payResponse : PropTypes.object,
    isMessage: PropTypes.bool,
    isLicensePlate: PropTypes.bool,
    screen: PropTypes.string,
    partnerDetails: PropTypes.object,
}

QRCodeComp.defaulProps = {
    dispatch: noop,
    paymentData : EMPTY_OBJECT,
    payResponse : EMPTY_OBJECT,
    isMessage: false,
    isLicensePlate: false,
    screen: undefined,
    partnerDetails: EMPTY_OBJECT,
}

function mapStateToProps() {
    return {}
}

export default connect(mapStateToProps)(QRCodeComp)